/**
 * 3D Logo Anfrage Handler (Native Option - 3 Step Wizard)
 * Handles client-side validation, 3 Step Nav, and complex email body formatting.
 */

document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('QuoteForm');
    if (!form) return;

    // --- Configuration ---
    const CONFIG = {
        maxFileSize: 15 * 1024 * 1024, // 15MB
        allowedExtensions: ['pdf', 'jpg', 'jpeg', 'png', 'svg'],
        workerUploadUrl: "https://iblaprint-upload.alnmrwesam9.workers.dev/upload"
    };

    const LABELS = {
        refPrefix: "IBLAprint Anfrage – 3D Logo (REF:",
    };

    // --- State ---
    let currentStep = 1;
    let isSubmitting = false;

    // Upload State
    const uploadState = {
        logo: { pending: false, url: null, error: false },
        montage: { pending: false, url: null, error: false }
    };

    // --- Wizard Navigation Logic ---
    const btnStep1Next = document.getElementById('btn_step1_next');
    const btnStep2Prev = document.getElementById('btn_step2_prev');
    const btnStep2Next = document.getElementById('btn_step2_next');
    const btnStep3Prev = document.getElementById('btn_step3_prev');

    if (btnStep1Next) btnStep1Next.addEventListener('click', () => { if (validateStep(1)) goToStep(2); });
    if (btnStep2Prev) btnStep2Prev.addEventListener('click', () => goToStep(1, true));
    if (btnStep2Next) btnStep2Next.addEventListener('click', () => { if (validateStep(2)) goToStep(3); });
    if (btnStep3Prev) btnStep3Prev.addEventListener('click', () => goToStep(2, true));

    function goToStep(step, isBack = false) {
        // Steps
        const steps = {
            1: document.getElementById('step_1'),
            2: document.getElementById('step_2'),
            3: document.getElementById('step_3')
        };
        const dots = {
            1: document.getElementById('dot_1'),
            2: document.getElementById('dot_2'),
            3: document.getElementById('dot_3')
        };
        const progressFill = document.getElementById('progress_fill');

        // Hide current
        const currentEl = steps[currentStep];
        if (currentEl) {
            currentEl.classList.remove('active', 'from-prev');
            currentEl.style.display = 'none';
        }

        // Show new
        const newEl = steps[step];
        if (newEl) {
            newEl.style.display = 'block';
            if (isBack) newEl.classList.add('from-prev');
            setTimeout(() => newEl.classList.add('active'), 10);
        }

        // Progress Bar
        // 3 steps: Start (0 or 33?), Step 2 (66), Step 3 (100)
        let percent = 0;
        if (step === 1) percent = 0;
        if (step === 2) percent = 50;
        if (step === 3) percent = 100;

        if (progressFill) progressFill.style.width = percent + '%';

        // Dots
        for (let i = 1; i <= 3; i++) {
            if (i < step) {
                dots[i].classList.add('completed');
                dots[i].classList.remove('active');
                dots[i].innerHTML = '✓';
            } else if (i === step) {
                dots[i].classList.add('active');
                dots[i].classList.remove('completed');
                dots[i].innerHTML = i;
            } else {
                dots[i].classList.remove('active', 'completed');
                dots[i].innerHTML = i;
            }
        }

        currentStep = step;
        updateSubmitButtonState();
    }

    // --- File Upload Logic ---
    const fileLogoInput = document.getElementById('file_logo');
    const fileMontageInput = document.getElementById('file_montage');

    if (fileLogoInput) {
        fileLogoInput.addEventListener('change', (e) => handleFileUpload(e, 'logo'));
    }
    if (fileMontageInput) {
        fileMontageInput.addEventListener('change', (e) => handleFileUpload(e, 'montage'));
    }

    async function handleFileUpload(event, kind) {
        const file = event.target.files[0];
        const statusEl = document.getElementById(`${kind}_status`);
        const urlInput = document.getElementById(`${kind}_url`);
        const errorEl = document.getElementById(`error_${kind}`);

        // Reset state
        uploadState[kind].pending = false;
        uploadState[kind].url = null;
        uploadState[kind].error = false;
        if (urlInput) urlInput.value = '';
        if (statusEl) statusEl.innerHTML = '';
        updateSubmitButtonState();

        if (!file) return;

        // Validation
        if (file.size > CONFIG.maxFileSize) {
            showError(`error_${kind}`, `Datei ist zu groß (Max 15MB).`);
            event.target.value = ''; // Clear file
            return;
        }

        // Hide local errors if format valid (basic format check inside validateFile called by validateStep, 
        // but we can do a quick check here too to avoid upload)
        const ext = file.name.split('.').pop().toLowerCase();
        if (kind === 'logo' && !CONFIG.allowedExtensions.includes(ext)) {
            showError(`error_${kind}`, `Format nicht erlaubt.`);
            event.target.value = '';
            return;
        }

        // Start Upload
        uploadState[kind].pending = true;
        updateSubmitButtonState();
        if (statusEl) statusEl.innerHTML = '<span style="color:#2563eb">Wird hochgeladen...</span>';

        const formData = new FormData();
        formData.append('file', file);
        formData.append('kind', kind);

        try {
            const response = await fetch(CONFIG.workerUploadUrl, {
                method: 'POST',
                body: formData
            });
            const data = await response.json();

            if (data && data.ok && data.url) {
                // Success
                uploadState[kind].pending = false;
                uploadState[kind].url = data.url;
                if (urlInput) urlInput.value = data.url;
                if (statusEl) statusEl.innerHTML = '<span style="color:#16a34a">Hochgeladen ✅</span>';
                if (errorEl) errorEl.classList.remove('show');
            } else {
                throw new Error('Upload returned invalid data');
            }
        } catch (err) {
            console.error('Upload Error:', err);
            uploadState[kind].pending = false;
            uploadState[kind].error = true;
            if (statusEl) statusEl.innerHTML = '<span style="color:#dc2626">Fehlgeschlagen ❌</span>';
            // Optional: keep file selected so user can retry? 
            // Or clear it? Let's keep it but show error.
            showError(`error_${kind}`, 'Upload fehlgeschlagen. Bitte erneut versuchen.');
        } finally {
            updateSubmitButtonState();
        }
    }

    function updateSubmitButtonState() {
        const btn = document.getElementById('submit_quote');
        if (!btn) return;

        // Check file requirements
        // Logo is required. Montage is optional.
        const logoHasFile = fileLogoInput && fileLogoInput.files.length > 0;
        const montageHasFile = fileMontageInput && fileMontageInput.files.length > 0;

        // Condition: 
        // 1. No pending uploads.
        // 2. If logo selected, must have url.
        // 3. If montage selected, must have url.
        // 4. Logo MUST be selected (handled by validateStep, but here we disable until upload)

        const isPending = uploadState.logo.pending || uploadState.montage.pending;
        const logoReady = logoHasFile ? !!uploadState.logo.url : false;
        // Note: If logic says Logo is required, we can't be "ready" if no file. 
        // But validateStep(3) handles "Required" check. This function handles "Upload Readiness".

        const montageReady = montageHasFile ? !!uploadState.montage.url : true; // If no file, ready.

        if (isPending) {
            btn.disabled = true;
            btn.innerText = 'Bitte warten (Upload)...';
        } else if ((logoHasFile && !logoReady) || (montageHasFile && !montageReady)) {
            // Upload failed or not finished (should be covered by pending, but covers error state)
            btn.disabled = true;
            btn.innerText = 'Upload ausstehend...';
        } else {
            btn.disabled = false;
            btn.innerText = 'Kostenlos anfragen';
        }
    }

    // --- Color Picker Logic ---
    const colorRadioCustom = document.querySelector('input[name="color_selection"][value="custom"]');
    const colorRadioDefault = document.querySelector('input[name="color_selection"][value="default"]');
    const colorPickerContainer = document.getElementById('color_picker_container');
    const colorPicker = document.getElementById('custom_color_picker');
    const colorInput = document.getElementById('custom_color_input');

    if (colorRadioCustom && colorRadioDefault) {
        const toggleColor = () => {
            if (colorRadioCustom.checked) {
                colorPickerContainer.classList.add('active');
                colorInput.value = colorPicker.value;
            } else {
                colorPickerContainer.classList.remove('active');
                colorInput.value = 'Standard (Nach Grafik)';
            }
        };

        [colorRadioCustom, colorRadioDefault].forEach(el => el.addEventListener('change', toggleColor));
        colorPicker.addEventListener('input', (e) => {
            if (colorRadioCustom.checked) colorInput.value = e.target.value;
        });
    }

    // --- Form Submission ---
    form.addEventListener('submit', (e) => {
        if (isSubmitting) { e.preventDefault(); return; }

        clearErrors();

        if (!validateStep(3)) {
            e.preventDefault();
            return;
        }

        // Validate uploads again (Redundant but safe)
        const logoHasFile = fileLogoInput && fileLogoInput.files.length > 0;
        const logoUrl = document.getElementById('logo_url').value;
        if (logoHasFile && !logoUrl) {
            e.preventDefault();
            alert('Bitte warten Sie, bis das Logo vollständig hochgeladen ist.');
            return;
        }

        // Lock form
        isSubmitting = true;
        setLoading(true);

        const refNum = 'REQ-' + Math.random().toString(36).substring(2, 6).toUpperCase();
        const bodyInput = document.getElementById('final_body_input');
        if (bodyInput) bodyInput.value = formatEmailBody(refNum);

        const subjectInput = document.querySelector('input[name="contact[subject]"]');
        if (subjectInput) subjectInput.value = `${LABELS.refPrefix} ${refNum})`;
    });

    // --- Validation Logic ---
    function validateStep(step) {
        let isValid = true;
        clearErrors();

        if (step === 1) {
            // Files & Dimensions
            const logoInput = document.getElementById('file_logo');
            if (logoInput) {
                if (!logoInput.files || logoInput.files.length === 0) {
                    showError('error_logo', 'Bitte laden Sie Ihr Logo hoch.');
                    isValid = false;
                } else {
                    if (!validateFile(logoInput.files[0], 'error_logo')) isValid = false;
                    // Check if upload failed
                    if (uploadState.logo.error) {
                        showError('error_logo', 'Upload fehlgeschlagen.');
                        isValid = false;
                    }
                }
            }
            if (!document.getElementById('width_cm').value || !document.getElementById('height_cm').value) {
                showError('error_dimensions', 'Bitte Breite und Höhe angeben.');
                isValid = false;
            }
            // Block Next if uploading?
            if (uploadState.logo.pending || uploadState.montage.pending) {
                // Ideally show a message?
                // For now, let them proceed, we block Submit at the end.
            }
        }

        if (step === 2) {
            // Material & Color
            if (!document.querySelector('input[name="material_selection"]:checked')) {
                showError('error_material', 'Bitte wählen Sie ein Material.');
                isValid = false;
            }
        }

        if (step === 3) {
            // Contact
            if (!document.getElementById('contact_email').value) {
                // Native should catch, but strict check here
            }
            if (!document.getElementById('privacy_check').checked) {
                showError('error_privacy', 'Bitte akzeptieren.');
                isValid = false;
            }
        }

        return isValid;
    }

    function validateFile(file, errorId) {
        if (file.size > CONFIG.maxFileSize) {
            showError(errorId, `Datei ist zu groß (Max 15MB).`);
            return false;
        }
        const ext = file.name.split('.').pop().toLowerCase();
        if (!CONFIG.allowedExtensions.includes(ext)) {
            showError(errorId, `Format nicht erlaubt.`);
            return false;
        }
        return true;
    }

    function showError(id, message) {
        const el = document.getElementById(id);
        if (el) {
            el.classList.add('show');
            if (message) el.innerText = message;
        }
    }

    function clearErrors() {
        document.querySelectorAll('.validation-error').forEach(el => el.classList.remove('show'));
    }

    function setLoading(isLoading) {
        const btn = document.getElementById('submit_quote');
        const spinner = '<span class="loading-spinner" style="display:inline-block; width:12px; height:12px; border:2px solid #fff; border-top-color:transparent; border-radius:50%; animation:spin 1s linear infinite; margin-left:8px;"></span>';
        if (isLoading) {
            btn.disabled = true;
            btn.classList.add('loading');
            btn.innerHTML = 'Wird gesendet...' + spinner;
        }
    }

    // --- Formatting ---
    function formatEmailBody(refNum) {
        const getVal = (id) => document.getElementById(id)?.value || '-';
        const getRadio = (name) => document.querySelector(`input[name="${name}"]:checked`)?.value || '-';

        const vorname = getVal('contact_firstname');
        const nachname = getVal('contact_lastname');
        const material = getRadio('material_selection');
        const color = getVal('custom_color_input') || 'Standard';
        const comment = getVal('contact_comment');

        const logoUrl = getVal('logo_url');
        const montageUrl = getVal('montage_url');

        const productTitle = document.querySelector('h1')?.innerText || '3D Logo';
        const now = new Date().toLocaleString('de-DE');

        return `
IBLAprint Anfrage – 3D Logo (REF: ${refNum})
==============================
PRODUKT: ${productTitle}
REF: ${refNum}
ZEIT: ${now}
URL: ${window.location.href}
==============================

SPEZIFIKATIONEN:
- Breite: ${getVal('width_cm')} cm
- Höhe: ${getVal('height_cm')} cm
- Material: ${material}
- Farbe: ${color}

ANHÄNGE (Downloads):
- Logo Datei: ${logoUrl ? logoUrl : 'Nicht hochgeladen'}
- Montage Foto: ${montageUrl ? montageUrl : 'Nicht hochgeladen'}

KONTAKT:
- Name: ${getVal('Anrede')} ${vorname} ${nachname}
- Email: ${getVal('contact_email')}
- Telefon: ${getVal('contact_phone')}
- Firma: ${getVal('contact_company')}

KOMMENTAR:
${comment}
        `.trim();
    }
});
